import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import {
  fetchAllSkillsCount,
  fetchAllSkillsMonthly,
  fetchAllEmployeeSkills,
  fetchAllSkillsEmployeeWise,
} from "../../../core/data/redux/reports/skills_report/skillsreport.Action";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

interface Skill {
  id: number;
  name: string;
  employeeList: Employee[];
}

interface Employee {
  EmployeeID: number;
  Name: string;
  Position: string;
  Department: string;
  Experience: string;
  Contact: string;
  Address: string;
}

interface Skill {
  SkillName: string;
  ProficiencyScore: number;
}

interface Employee {
  Name: string;
  Position: string;
  Department: string;
  EmployeeID: number;
  skills: Skill[];
  PictureURL: string | null;
}

interface SkillGroup {
  name: string;
  id: number;
  employeeList: Employee[];
}
interface SkillMatrixReportProps {
  showOnlySkillList?: boolean;
}


const SkillMatrixReport: React.FC<SkillMatrixReportProps> = ({ showOnlySkillList }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const [tableKey, setTableKey] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("Pending");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedYear, setSelectedYear] = useState("2025");
  const [count, setcount] = useState<any>();
  const [monthly, setmonthly] = useState<any>();
  const { Training } = useSelector((state: any) => state.training.training);
  const [selectedSkill, setSelectedSkill] = useState<Skill | null>(null);
  const [skillsList, setSkillsList] = useState([]);
  const [skillemployeewise, setskillemployeewise] = useState<any>([]);
  const data : any = skillemployeewise;
  const handleSkillClick = (skill: Skill) => {
    setSelectedSkill(skill);
  };


  function filterEmployeeSkillData(data: any[]) {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return data.map(emp => ({
    EmployeeName: emp.EmployeeName || "N/A",
    SkillName: emp.SkillName || "N/A",
    Year: emp.Year || "N/A",
    Month: monthNames[(emp.Month || 1) - 1] 
  }));
}

const data2 = filterEmployeeSkillData(data)

  const columns = [
    {
      title: "Skills",
      dataIndex: "Skill",
      key: "Skill",
      render: (text: string) => text || "N/A",
      sorter: (a: any, b: any) => a.Skill.length - b.Skill.length,
    },
    {
      title: "Count",
      dataIndex: "Employees",
      key: "Count",
      render: (employees: string[]) => employees.length,
      sorter: (a: any, b: any) => a.Employees.length - b.Employees.length,
    },
    {
      title: "Employee Names",
      dataIndex: "Employees",
      key: "Employees",
      render: (employees: string[]) => (
        <div style={{ maxHeight: 120, overflowY: "auto" }}>
          {employees.map((name, index) => (
            <div key={index}>{name}</div>
          ))}
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(fetchAllSkillsCount()).then((res) => {
      setcount(res.payload.data);
    });
    dispatch(fetchAllSkillsMonthly(selectedYear)).then((res) => {
      setmonthly(res.payload.data);
    });
    dispatch(fetchAllEmployeeSkills()).then((res) => {
      setSkillsList(res.payload.data);
    });
    dispatch(fetchAllSkillsEmployeeWise(selectedYear)).then((res) => {
      setskillemployeewise(res.payload.data);
    });
  }, []);

  useEffect(() => {
    if (monthly) {
      const skillCountsByMonth = new Array(12).fill(0);

      monthly.forEach((item: any) => {
        if (item.Month >= 1 && item.Month <= 12) {
          skillCountsByMonth[item.Month - 1] = item.SkillCount;
        }
      });

      const maxValue = Math.max(...skillCountsByMonth);
      const yAxisMax = Math.ceil(maxValue / 5) * 5 || 5;

      setchart((prev: any) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: skillCountsByMonth,
          },
        ],
        yaxis: {
          ...prev.yaxis,
          max: yAxisMax,
          tickAmount: 5,
          labels: {
            offsetX: -15,
            formatter: (val: number) => val.toString(),
          },
        },
      }));
    }
  }, [monthly]);

  useEffect(() => {
    if (skillemployeewise && skillemployeewise.length > 0) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const employeeMap: Record<string, any[]> = {};

      skillemployeewise.forEach((item: any) => {
        const name = item.EmployeeName;
        const monthIndex = item.Month - 1;
        const monthLabel = months[monthIndex];

        if (!employeeMap[name]) {
          employeeMap[name] = months.map((m, i) => ({
            x: m,
            y: 0,
            skillNames: [],
          }));
        }

        employeeMap[name][monthIndex].y += 1;
        employeeMap[name][monthIndex].skillNames.push(item.SkillName);
      });

      const seriesData = Object.entries(employeeMap).map(
        ([employee, data]) => ({
          name: employee,
          data,
        })
      );

      const allValues = seriesData.flatMap((s) => s.data.map((d: any) => d.y));
      const maxValue = Math.max(...allValues);
      const yAxisMax = Math.ceil(maxValue / 5) * 5 || 5;

      setSkillemployeewiseChart((prev: any) => ({
        ...prev,
        series: seriesData,
        yaxis: {
          ...prev.yaxis,
          max: yAxisMax,
          tickAmount: 5,
        },
      }));
    }
  }, [skillemployeewise , selectedYear]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllSkillsMonthly(selectedYear)).then((res) => {
        setmonthly(res.payload.data);
      });
      dispatch(fetchAllSkillsEmployeeWise(selectedYear)).then((res) => {
        setskillemployeewise(res.payload.data);
      });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const [chart, setchart] = useState<any>({
    series: [
      {
        name: "Skiils",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 190,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#FF9F43"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "",
      align: "left",
    },
    // grid: {
    //   row: {
    //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //     opacity: 0.5
    //   },
    // },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => {
          return val / 1;
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  const [skillemployeewiseChart, setSkillemployeewiseChart] = useState<any>({
    series: [],
    chart: {
      height: 190,
      type: "bar",
      zoom: { enabled: false },
    },
    colors: ["#FF9F43", "#7367F0", "#28C76F", "#EA5455", "#00CFE8"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 10,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => val.toString(),
      },
    },
    legend: {
      show: false, // hide legend
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
        const employeeName = w.globals.seriesNames[seriesIndex];
        const dataPoint = w.config.series[seriesIndex].data[dataPointIndex];

        const skillList = Array.isArray(dataPoint.skillNames)
          ? dataPoint.skillNames.join(", ")
          : "N/A";

        const value = dataPoint?.y ?? 0;

        return `
      <div style="padding:8px">
        <strong>Employee:</strong> ${employeeName}<br/>
        <strong>Skill(s):</strong> ${skillList}<br/>
      </div>
    `;
      },
    },
  });
// If user wants only the Skill List section
if (showOnlySkillList) {
  return (
    <div
      className="card"
      style={{
        height: "400px",
        overflow: "hidden",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <div className="card-body p-0" style={{ height: "400px" }}>
        <div className="d-flex" style={{ height: "400px" }}>
          
          {/* Sidebar - Skill List */}
          <div
            className="skills-list"
            style={{
              width: "25%",
              backgroundColor: "#f4f4f4",
              padding: "10px",
              borderRight: "1px solid #ddd",
              overflowY: "auto",
              height: "100%",
            }}
          >
            <h5>Skills List</h5>
            <ul className="list-group">
              {skillsList.map((skill: any) => (
                <li
                  key={skill.id}
                  className="list-group-item"
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#f8f9fa",
                    marginBottom: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#333",
                    fontWeight: 500,
                  }}
                  onClick={() => handleSkillClick(skill)}
                >
                  {skill.name}
                  <span
                    style={{
                      backgroundColor: "#007bff",
                      color: "#fff",
                      borderRadius: "50%",
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    {skill?.employeeListCount}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Employee Profiles */}
          <div
            className="employee-profiles"
            style={{
              width: "75%",
              padding: "20px",
              overflowY: "auto",
              height: "75%",
              backgroundColor: "#ffffff",
            }}
          >
            {selectedSkill ? (
              <div style={{ height: "100%", overflowY: "auto" }}>
                <div
                  className="employee-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "20px",
                    height: "300px",
                  }}
                >
                  {selectedSkill.employeeList.map((emp: Employee) => {
                    const scores = emp.skills?.map(s => s.ProficiencyScore) || [];
                    const avgScorePercent = scores.length
                      ? Math.round(
                          (scores.reduce((a, b) => a + b, 0) / scores.length) * 10
                        )
                      : 0;
                    const avgScoreOutOfTen = avgScorePercent / 10;

                    return (
                      <div
                        key={emp.EmployeeID}
                        className="profile-card"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #e0e0e0",
                          borderRadius: "16px",
                          maxHeight: "600px",
                          maxWidth: "500px",
                          overflowY: "auto",
                          padding: "10px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                          textAlign: "center",
                        }}
                      >
                        <h6>{emp.Name}</h6>
                        <p>{emp.Position}</p>

                        <div style={{ width: 60, margin: "10px auto" }}>
                          <CircularProgressbar
                            value={avgScorePercent}
                            text={`${avgScoreOutOfTen.toFixed(1)}`}
                          />
                        </div>

                        {emp.skills?.map((skill, idx) => (
                          <div key={idx}>{skill.SkillName} — {skill.ProficiencyScore}/10</div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <p>Select a skill to view employee profiles.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Organisation Skill Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Skills
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Skills_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Skills_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                {/* Box 1 */}
                <div className="col-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Skills
                          </span>
                          <h5>{count?.[0].total_unique_skills}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            {" "}
                            <i className="ti ti-tools" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Box 2 */}
                <div className="col-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            New Skills
                          </span>
                          <h5>{count?.[0].skill_count_this_month}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            {" "}
                            <i className="ti ti-tools" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            New Employee
                          </span>
                          <h5>{count?.[0].total_employees}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            {" "}
                            <i className="ti ti-users" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Chart (50%) */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header border-0 py-2 px-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i
                        className="ti ti-square-filled fs-12 me-2"
                        style={{ color: "#FF9F43" }}
                      />
                      Skill Chart
                    </p>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end p-2">
                        {["2025", "2024", "2023"].map((year) => (
                          <li key={year}>
                            <Link
                              to="#"
                              className="dropdown-item rounded-1"
                              onClick={() => handleYearSelect(year)}
                            >
                              {year}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-1 px-2">
                  <ReactApexChart
                    id="expense-analysis"
                    options={chart}
                    series={chart.series}
                    type="area"
                    height={180}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header border-0 py-2 px-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i
                        className="ti ti-square-filled fs-12 me-2"
                        style={{ color: "#FF9F43" }}
                      />
                      Skill Matrix
                    </p>
                    
                  </div>
                </div>
                <div className="card-body py-1 px-2">
                  <ReactApexChart
                    options={skillemployeewiseChart}
                    series={skillemployeewiseChart.series}
                    type="bar"
                    height={180}
                  />
                </div>
              </div>
            </div>
          </div>
{/* Skill List */}
          <div
            className="card"
            style={{
              height: "400px",
              overflow: "hidden",
              border: "1px solid #ccc",
              borderRadius: "8px",
            }}
          >
            <div className="card-body p-0" style={{ height: "400px" }}>
              <div className="d-flex" style={{ height: "400px" }}>
                {/* Sidebar - Skill List */}
                <div
                  className="skills-list"
                  style={{
                    width: "25%",
                    backgroundColor: "#f4f4f4",
                    padding: "10px",
                    borderRight: "1px solid #ddd",
                    overflowY: "auto",
                    height: "100%",
                  }}
                >
                  <h5>Skills List</h5>
                  <ul className="list-group">
                    {skillsList.map((skill: any) => (
                      <li
                        key={skill.id}
                        className="list-group-item"
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#f8f9fa",
                          marginBottom: "8px",
                          display: "flex", // ➤ Flex layout
                          justifyContent: "space-between", // ➤ Push span to the right
                          alignItems: "center", // ➤ Vertical centering
                          color: "#333", // ➤ Same text color
                          fontWeight: 500,
                        }}
                        onClick={() => handleSkillClick(skill)}
                      >
                        {skill.name}{" "}
                        <span
                          style={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {skill?.employeeListCount}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="employee-profiles"
                  style={{
                    width: "75%",
                    padding: "20px",
                    overflowY: "auto",
                    height: "75%",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {selectedSkill ? (
                    <div style={{ height: "100%", overflowY: "auto" }}>
                      <div
                        className="employee-grid"
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(4, 1fr)",
                          gap: "20px",
                          height: "300px",
                        }}
                      >
                        {selectedSkill.employeeList.map((emp: Employee) => {
                          const scores: number[] =
                            emp.skills?.map((s) => s.ProficiencyScore) || [];
                          const avgScorePercent: number =
                            scores.length > 0
                              ? Math.round(
                                  (scores.reduce((a, b) => a + b, 0) /
                                    scores.length) *
                                    10
                                )
                              : 0;

                          const avgScoreOutOfTen: number = avgScorePercent / 10;

                          return (
                            <div
                              key={emp.EmployeeID}
                              className="profile-card"
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e0e0e0",
                                borderRadius: "16px",
                                maxHeight: "600px",
                                maxWidth: "500px",
                                overflowY: "auto",
                                padding: "10px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                                textAlign: "center",
                                transition: "transform 0.2s",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "scale(1.02)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = "scale(1)")
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "8px",
                                  margin: "8px 0 4px",
                                }}
                              >
                                <span
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    backgroundColor: "#007bff22",
                                    color: "#007bff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    border: "2px solid #007bff",
                                  }}
                                >
                                  {emp.Name?.charAt(0).toUpperCase()}
                                </span>
                                <h6
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    margin: 0,
                                    color: "#333",
                                  }}
                                >
                                  {emp.Name}
                                </h6>
                              </div>

                              <p
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  marginBottom: "6px",
                                }}
                              >
                                {emp.Position}
                              </p>

                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "#555",
                                  backgroundColor: "#f2f2f2",
                                  padding: "4px 10px",
                                  borderRadius: "10px",
                                  display: "inline-block",
                                  marginBottom: "10px",
                                }}
                              >
                                {emp.Department}
                              </span>

                              {/* Circular Progress - Average Score */}
                              <div
                                style={{
                                  width: 60,
                                  height: 60,
                                  margin: "10px auto",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <CircularProgressbar
                                  value={avgScorePercent}
                                  text={`${avgScoreOutOfTen.toFixed(1)}`}
                                  styles={buildStyles({
                                    textSize: "16px",
                                    pathColor: "#007bff",
                                    textColor: "#333",
                                    trailColor: "#e6e6e6",
                                    backgroundColor: "#fff",
                                  })}
                                />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                {emp.skills
                                  ?.sort((a, b) =>
                                    a.SkillName.localeCompare(b.SkillName)
                                  )
                                  .map((skill, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        backgroundColor: "#f0f8ff",
                                        color: "#333",
                                        padding: "6px 12px",
                                        marginBottom: "6px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        width: "100%",
                                      }}
                                    >
                                      <span>{skill.SkillName}</span>
                                      <span style={{ color: "#007bff" }}>
                                        {skill.ProficiencyScore}/10
                                      </span>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <p>Select a skill to view employee profiles.</p>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2024 - 2025© hrmtree.</p>
        <p>
          Developed By{" "}
          <Link to="#" className="text-primary">
            Leadchain Systems
          </Link>
        </p>
      </div>
    </>
  );
};

export default SkillMatrixReport;
